// What the customer sees of embed mode (embed.js): the page is a full-screen layer over the store's product page.
//   - A Close (×) in the header, and a Close on the loading screen. It sends rg:close, and the store page closes the layer.
//   - When the customer has worked on the design (a photo, their own text, a list of names), the page asks
//     "Leave without saving your design?" first, in the page itself. The draft stays saved in the browser either way,
//     so the customer can come back to it. A design that is still only the starter name leaves at once.
//   - Esc does the same as Close (when no other box is open and no text is being typed).

import { $ } from "./util.js";

// embed: the result of startEmbed(). Returns { setEditor } (the editor is not there yet while the product loads).
export function initEmbedUi({ embed }) {
  const closeBtn = $("btnEmbedClose"), box = $("leaveBox"), scrim = $("leaveScrim"), stay = $("btnLeaveNo"), leave = $("btnLeaveYes");
  const review = $("review");
  let editor = null, lastFocus = null;

  document.body.classList.add("embedded");
  closeBtn.hidden = false;
  const early = document.createElement("button");           // the loading screen has no header, so it has its own Close
  early.type = "button"; early.className = "btn"; early.textContent = "Close";
  early.addEventListener("click", () => embed.close());
  $("stateActions").append(early);

  const isOpen = () => !box.hidden;
  function ask() {
    lastFocus = document.activeElement;
    scrim.hidden = false; box.hidden = false;
    stay.focus();                                            // the safe choice is the one under the cursor
  }
  function hide(restoreFocus) {
    box.hidden = true; scrim.hidden = true;
    if (restoreFocus && lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
  }
  function goAway() {
    hide(false);
    if (editor && editor.hasWork()) editor.saveDraftNow();   // the draft is in the browser before the frame goes
    embed.close();
  }
  // Close, or Esc: nothing to lose (still loading, or only the starter name) leaves at once; a design the customer worked on asks first.
  function request() {
    if (isOpen()) return;
    if (!editor || !editor.hasWork()) goAway(); else ask();
  }

  closeBtn.addEventListener("click", request);
  stay.addEventListener("click", () => hide(true));
  scrim.addEventListener("click", () => hide(true));
  leave.addEventListener("click", goAway);

  // In the capture phase, so the boxes that close themselves on Esc (the check dialog with its gifts strip) are still open when we look.
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      if (isOpen()) { e.preventDefault(); hide(true); return; }
      if (!review.hidden || document.querySelector(".adjust-layer")) return;
      const t = e.target;
      if (t && t.closest && t.closest("input, textarea, select, [contenteditable]")) return;   // Esc while typing is not "leave"
      request();
      return;
    }
    if (e.key === "Tab" && isOpen()) {                       // keep keyboard focus inside the question
      const items = [stay, leave], first = items[0], last = items[items.length - 1];
      if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }, true);

  return { setEditor(e) { editor = e; } };
}
